import { useState } from "react";
import { IFile } from "./UploadPhotos";
const greyCrossSvg = require("../assets/images/svg/grey-cross.svg").default;

export interface IImageListItemProps {
  file: IFile;
  handleArchiveImages: (id: string[], listId: string, index: number) => void;
  index: number;
}
const ImageListItem = ({
  file,
  handleArchiveImages,
  index,
}: IImageListItemProps) => {
  const fileId = file.id.length ? [file.id] : [];
  const handleCrossClicked = () => {
    handleArchiveImages(fileId, file.listId, index);
  };
  return (
    <div className="image-list-main">
      <div className="lft-main">
        <img src={file.Base64Content} className="car-img" alt="car icon" />
        <p className="image-title">{file.FileName}</p>
      </div>
      <div className="rt-main">
        <div className="size-chip">{file.imageSize}</div>
        <div className="vertical-border"></div>
        {!file.deleting ? (
          <img
            onClick={handleCrossClicked}
            src={greyCrossSvg}
            className="grey-cross-icon"
            alt="grey-cross-icon"
          />
        ) : (
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageListItem;
